import { replaceAsciiCharWithSlash } from '../utils/resolveBranch';
import { VCS as ENV_VCS, VCS_LINK as ENV_VCS_LINK } from './env';
export const USER_INFO_TYPES = {
    // RAW_COMMIT_AUTHOR: 1,
    // GITLAB_EMAIL: 2,
    // GITHUB_EMAIL: 3,
    BITBUCKET_EMAIL: 4,
    // UNUSED_EMAIL_FROM_INVITATION: 5,
    GITHUB_CUSTOM_EMAIL: 6,
};
export const COMMIT_STATUS = {
    NEW: 0,
    PROCESSING: 1,
    DONE: 2,
    FAIL: 3,
    TIMEOUT: 4,
};
export const REPORT_STATUS = {
    NEW: 1,
    PROCESSING: 2,
    SUCCESS: 3,
    FAILURE: 4,
    INVALID_CONFIG: 5,
    TIMEOUT: 6,
};
export const ORGANIZATION_PAYMENT_STATUS = {
    NONE: 0,
    WAITING_FOR_CARD: 1,
    VALID: 2,
    ERROR: 3,
    INVALID_CARD: 4,
};
export const MAX_REPOSITORY_SIZE = 209715200; // 200 MiB
export const GHA_INSTALLATION_TYPES = {
    USER: 1,
    ORGANIZATION: 2,
};
export const VCS = {
    BITBUCKET: 1,
    GITHUB: 2,
    GITLAB: 3,
    GITLAB_APESIGHT: 4,
    GITLAB_MONKEYDATA: 5,
    GITLAB_CHANDRA_SINGH: 7,
    ENTERPRISE: 8,
    GITLAB_MOBILESOFT: 9,
    GITLAB_KRAJVYSOCINA: 11,
    GITLAB_SPOLEKBISON: 12,
};
export const VCS_SLUG = {
    [VCS.BITBUCKET]: 'bitbucket',
    [VCS.GITHUB]: 'github',
    [VCS.GITLAB]: 'gitlab',
    [VCS.GITLAB_APESIGHT]: 'gitlab_apesight',
    [VCS.GITLAB_MONKEYDATA]: 'monkeydata',
    [VCS.GITLAB_CHANDRA_SINGH]: 'chandrasingh',
    [VCS.ENTERPRISE]: 'enterprise',
    [VCS.GITLAB_MOBILESOFT]: 'mobilesoft',
    [VCS.GITLAB_KRAJVYSOCINA]: 'krajvysocina',
    [VCS.GITLAB_SPOLEKBISON]: 'spolekbison',
    [VCS.ENTERPRISE]: 'enterprise',
};
const VCS_ICONS = {
    [VCS.BITBUCKET]: 'bitbucket',
    [VCS.GITHUB]: 'github',
    [VCS.GITLAB]: 'gitlab',
    [VCS.GITLAB_APESIGHT]: 'gitlab',
    [VCS.GITLAB_MONKEYDATA]: 'gitlab',
    [VCS.GITLAB_KRAJVYSOCINA]: 'gitlab',
    [VCS.GITLAB_SPOLEKBISON]: 'gitlab',
    [VCS.ENTERPRISE]: 'gitlab',
};
export function getVcsIdBySlug(slug) {
    const vcsId = Object.keys(VCS_SLUG).find(vcs => VCS_SLUG[vcs] === slug);
    if (!vcsId) {
        return null;
    }
    return Number(vcsId);
}
export const VCS_ICON = {
    ...VCS_ICONS,
    [VCS.ENTERPRISE]: VCS_ICONS[String(ENV_VCS)] || 'gitlab',
};
const VCS_LINKS = {
    [VCS.BITBUCKET]: 'https://bitbucket.org',
    [VCS.GITHUB]: 'https://github.com',
    [VCS.GITLAB]: 'https://gitlab.com',
    [VCS.GITLAB_APESIGHT]: 'https://gitlab.staging.codeac.io',
    [VCS.GITLAB_MONKEYDATA]: 'https://gitlab.monkeydata.com',
    [VCS.GITLAB_CHANDRA_SINGH]: 'http://52.41.71.162',
    [VCS.ENTERPRISE]: ENV_VCS_LINK,
    [VCS.GITLAB_MOBILESOFT]: 'https://git.mobilesoft.cz',
    [VCS.GITLAB_KRAJVYSOCINA]: 'https://gitlab-ext.kr-vysocina.cz',
    [VCS.GITLAB_SPOLEKBISON]: 'https://gitlab.spolek-bison.cz',
};
export const VCS_LINK = {
    ...VCS_LINKS,
    ...(!ENV_VCS ? {} : { [ENV_VCS]: ENV_VCS_LINK }),
};
const GITLAB_SELFHOSTED = [
    VCS.GITLAB_APESIGHT,
    VCS.GITLAB_MONKEYDATA,
    VCS.GITLAB_CHANDRA_SINGH,
    VCS.GITLAB_MOBILESOFT,
    VCS.GITLAB_KRAJVYSOCINA,
    VCS.GITLAB_SPOLEKBISON,
];
export function resolveVcs(slug) {
    const vcsId = getVcsIdBySlug(slug);
    if (!vcsId) {
        return '';
    }
    if (slug === VCS_SLUG[VCS.ENTERPRISE]) {
        return VCS_SLUG[ENV_VCS || VCS.ENTERPRISE];
    }
    else if (GITLAB_SELFHOSTED.includes(vcsId)) {
        return VCS_SLUG[VCS.GITLAB];
    }
    return slug;
}
const VCS_COMMIT_LINK = {
    [VCS.BITBUCKET]: '/%repositoryFullname%/commits/%hash%',
    [VCS.GITHUB]: '/%repositoryFullname%/commit/%hash%',
    [VCS.GITLAB]: '/%repositoryFullname%/commit/%hash%',
};
const VCS_PR_LINK = {
    [VCS.BITBUCKET]: '/%repositoryFullname%/pull-requests/%prId%',
    [VCS.GITHUB]: '/%repositoryFullname%/pull/%prId%',
    [VCS.GITLAB]: '/%repositoryFullname%/merge_requests/%prId%',
};
export const VCS_FROM_SLUG = Object.keys(VCS_SLUG).reduce((obj, key) => ({ ...obj, [VCS_SLUG[key]]: Number(key) }), {});
const encodeFullName = (fullname) => replaceAsciiCharWithSlash(fullname);
export const getVcsCommitLink = (vcs, repositoryFullname, hash) => VCS_LINK[VCS_FROM_SLUG[vcs]] +
    VCS_COMMIT_LINK[VCS_FROM_SLUG[resolveVcs(vcs)]]
        .replace('%repositoryFullname%', encodeFullName(repositoryFullname))
        .replace('%hash%', hash);
export const getVcsPrLink = (vcs, repositoryFullname, prId) => VCS_LINK[VCS_FROM_SLUG[vcs]] +
    VCS_PR_LINK[VCS_FROM_SLUG[resolveVcs(vcs)]]
        .replace('%repositoryFullname%', encodeFullName(repositoryFullname))
        .replace('%prId%', String(prId));
export const ISSUES_GROUP = {
    ALL: 'all',
    ERRORS: 'errors',
    WARNINGS: 'warnings',
};
export const DEFAULT_TIMEOUT = 3000;
export const ALLOWED_COVERAGE_LANGUAGES = [
    'JavaScript',
    // 'PHP',
];
export const SUPPORT_EMAIL = 'support@codeac.io';
